import { css } from "@emotion/react";

const buttonCopy = css`
  padding: 0;
  margin-left: 8px;
`;

const boxWrapper = ({ theme }) => css`
  position: relative;
  margin-bottom: 50px;

  padding: 20px;

  @media (min-width: ${theme.screenSizes.mdMax}) {
    margin-bottom: 70px;
    padding: 52px;
  }
`;

export const addStyles = {
  buttonCopy,
  boxWrapper,
};
